import { configureStore } from '@reduxjs/toolkit';
import authReducer from 'core/features/auth/authSlice';
import projectsReducer from 'core/features/projects/projectsSlice';
import sicherheitReducer from 'core/features/sicherheit/sicherheitSlice';
import { MODULES } from 'modules';

/**
 * Zentraler Redux-Store.
 *
 * Der allgemeine Teil (auth, projects) kommt aus src/core; alle weiteren
 * Reducer liefern die Module über ihre Definition (`reducers`) selbst mit.
 *
 * ▶ NEUEN STATE-BEREICH HINZUFÜGEN: im Modul unter `reducers` registrieren –
 *   hier ist keine Änderung nötig.
 */
const modulReducer = MODULES.reduce(
  (alle, modul) => Object.assign(alle, modul.reducers),
  {}
);

export const store = configureStore({
  reducer: {
    auth: authReducer,
    projects: projectsReducer,
    sicherheit: sicherheitReducer,
    ...modulReducer,
  },
});
